import { render } from "./PasswordResetSessionForm.vue?vue&type=template&id=4a219f9a&scoped=true"
import script from "./PasswordResetSessionForm.vue?vue&type=script&lang=js"
export * from "./PasswordResetSessionForm.vue?vue&type=script&lang=js"

import "./PasswordResetSessionForm.vue?vue&type=style&index=0&id=4a219f9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a219f9a"]])

export default __exports__